module.exports = __webpack_public_path__ + "static/media/logo-grey3.ad4c0d4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-grey3.svg
// module id = 1122
// module chunks = 0